import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import React from 'react';

import { DATE_MONTH_DAY_YEAR_WITH_DASH } from '../../constants';
import Strings from '../../Strings';
import { getCapChargeText } from '../../utils';

const CHARGING_STATE_LABELS = {
  charging: () => Strings.charging.charging,
  not_charging: () => Strings.charging.notCharging,
  usb_connected_not_charging: () => Strings.charging.fullUsbConnected,
};

export const formatChargingStatusTimestamp = dateTime => {
  if (typeof dateTime !== 'string') return undefined;

  const date = moment(dateTime);
  if (!date.isValid()) return undefined;
  return date.format(DATE_MONTH_DAY_YEAR_WITH_DASH);
};

export const getChargingStatusLabel = chargingStatus => {
  const getLabel = CHARGING_STATE_LABELS[chargingStatus?.state];
  return getLabel ? getLabel() : undefined;
};

export const getBatteryTooltip = ({ battery, batteryMeasuredAt, chargingStatus }) => {
  const lines = [];
  const batteryTimestamp = formatChargingStatusTimestamp(batteryMeasuredAt);
  const batteryLevel = Number(battery);
  if (batteryTimestamp && Number.isFinite(batteryLevel) && batteryLevel !== -100) {
    lines.push(Strings.formatString(Strings.charging.lastBatteryLevel, batteryLevel, batteryTimestamp));
  }

  const chargingLabel = getChargingStatusLabel(chargingStatus);
  const chargingTimestamp = formatChargingStatusTimestamp(chargingStatus?.updated_at);
  if (chargingLabel && chargingTimestamp) {
    lines.push(Strings.formatString(Strings.charging.lastChargingStatus, chargingLabel, chargingTimestamp));
  }

  return lines.length > 0 ? lines.join('<br />') : undefined;
};

export function BatteryWithChargingStatus({ battery, batteryMeasuredAt, chargingStatus }) {
  const tooltip = getBatteryTooltip({ battery, batteryMeasuredAt, chargingStatus });
  if (!tooltip) return getCapChargeText(battery);

  return (
    <span data-testid="battery-charging-status" data-tooltip-html={tooltip} data-tooltip-id="tooltip">
      {getCapChargeText(battery)}
    </span>
  );
}

BatteryWithChargingStatus.propTypes = {
  battery: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  batteryMeasuredAt: PropTypes.string,
  chargingStatus: PropTypes.shape({
    state: PropTypes.oneOf(['charging', 'not_charging', 'usb_connected_not_charging']),
    updated_at: PropTypes.string,
  }),
};
